import { RouteObject } from "react-router";
import { Redirect } from "src/router/helper/Redirect";

export const SigningRoute: RouteObject = {
  path: "signing/:signedDocumentId",
  async loader(args) {
    const { signedDocumentLoader } = await import("src/router/loaders/jobs/Signatures");
    return signedDocumentLoader(args);
  },
  async lazy() {
    const { SigningRecipientsModal } = await import("jobs/Job/ContractsTab/SigningRecipientsModal");
    return { element: <SigningRecipientsModal /> };
  },
};

export const SigningHistoryRoute: RouteObject = {
  path: ":signedDocumentId/signing_history",
  async loader(args) {
    const { signedDocumentLoader } = await import("src/router/loaders/jobs/Signatures");
    return signedDocumentLoader(args);
  },
  async lazy() {
    const { SigningHistoryModal } = await import("jobs/Job/SignaturesTab/SigningHistoryModal");
    return { element: <SigningHistoryModal /> };
  },
};

export const VoidSignedDocumentRoute: RouteObject = {
  path: ":signedDocumentId/void",
  async loader(args) {
    const { signedDocumentLoader } = await import("src/router/loaders/jobs/Signatures");
    return signedDocumentLoader(args);
  },
  async lazy() {
    const { VoidSignedDocumentModal } = await import("jobs/Job/SignaturesTab/VoidSignedDocumentModal");
    return { element: <VoidSignedDocumentModal /> };
  },
};

export const SignatureRequestRoute: RouteObject = {
  path: "signature_request",
  async lazy() {
    const { SignatureRequest } = await import("jobs/Job/SignaturesTab/SignatureRequest");
    return { element: <SignatureRequest /> };
  },
  async loader(args) {
    const { signatureRequestLoader } = await import("src/router/loaders/jobs/Signatures");
    return signatureRequestLoader(args);
  },
};

const CatchAllRoute: RouteObject = {
  path: "*",
  element: <Redirect to=".." />,
};

export const SignatureRoutes: RouteObject[] = [
  {
    path: "estimate_documents",
    async lazy() {
      const { SignatureDocumentsTable } = await import("jobs/Job/SignaturesTab/SignatureDocumentsTable");
      return { element: <SignatureDocumentsTable /> };
    },
    async loader(args) {
      const { estimateDocumentsLoader } = await import("src/router/loaders/jobs/Signatures");
      return estimateDocumentsLoader(args);
    },
    children: [SigningRoute, SigningHistoryRoute, VoidSignedDocumentRoute, SignatureRequestRoute, CatchAllRoute],
  },
  {
    path: "signable_documents",
    async lazy() {
      const { SignatureDocumentsTable } = await import("jobs/Job/SignaturesTab/SignatureDocumentsTable");
      return { element: <SignatureDocumentsTable /> };
    },
    async loader(args) {
      const { signableDocumentsLoader } = await import("src/router/loaders/jobs/Signatures");
      return signableDocumentsLoader(args);
    },
    children: [SigningRoute, SigningHistoryRoute, VoidSignedDocumentRoute, SignatureRequestRoute, CatchAllRoute],
  },
  { path: "", element: <Redirect to="estimate_documents" /> },
];
